import { ValueOfObjectFields } from "shared/lib/interfaces/utils";
import clsx from "clsx";
import { FC } from "react";

import {
  DISPOSITIONS,
  DISPOSITIONS_STRING_MAP,
  DISPOSITIONS_V3,
  DISPOSITIONS_V3_MAP,
  DISPOSITION_SPECIFICS,
  DISPOSITION_SPECIFICS_MAP,
} from "shared/lib/constants/dispositions";

export const DISPOSITION_BADGE_CSS_PROPERTIES = {
  [DISPOSITIONS.BOOKED_MEETING as string]: {
    color: "text-black/80",
    bg: "bg-[#DFF4B4]",
  },
  [DISPOSITIONS.TENTATIVE_INTEREST]: {
    color: "text-black/80",
    bg: "bg-[#DFF4B4]",
  },
  [DISPOSITIONS.NO_PICK_UP]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITIONS.CALLBACK_BOOKED]: {
    color: "text-black/80",
    bg: "bg-[#F2FBE1]",
  },
  [DISPOSITIONS.NOT_INTERESTED]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITIONS.NOT_QUALIFIED]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITIONS.BAD_DATA]: {
    color: "text-black/80",
    bg: "bg-[#FF9E89]",
  },
  [DISPOSITIONS.OTHER]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITIONS.AE_NOTE]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITIONS.CANCELLED_MEETING]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITIONS.ACCOUNT_DNC]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITIONS.MEETING_NO_SHOW]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITIONS.MEETING_RESCHEDULED]: {
    color: "text-black/80",
    bg: "bg-[rgba(0,0,0,.08)]",
  },
  [DISPOSITIONS.MEETING_NOT_QUALIFIED]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITIONS.MEETING_QUALIFIED]: {
    color: "text-black/80",
    bg: "bg-[#DFF4B4]",
  },

  // V3 Dispositions
  [DISPOSITIONS_V3.INTERESTED]: {
    color: "text-black/80",
    bg: "bg-[#DFF4B4]",
  },
  [DISPOSITIONS_V3.PITCH_REJECTED]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITIONS_V3.INTRO_REJECTED]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITIONS_V3.NOT_QUALIFIED_NEED]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITIONS_V3.NOT_QUALIFIED_TIMING]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITIONS_V3.DO_NOT_CALL]: {
    color: "text-black/80",
    bg: "bg-[#FF9E89]",
  },
  [DISPOSITIONS_V3.QC_NOT_MET_FOR_ACCOUNT]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITIONS_V3.OTHER_FOLLOW_UP]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITIONS_V3.OTHER_DO_NOT_FOLLOW_UP]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },

  // DISPOSITION_SPECIFICS
  [DISPOSITION_SPECIFICS.MORE_MATERIALS]: {
    color: "text-black/80",
    bg: "bg-[#F2FBE1]",
  },
  [DISPOSITION_SPECIFICS.VOICEMAIL_LEFT]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITION_SPECIFICS.VOICEMAIL_NOT_LEFT]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITION_SPECIFICS.PITCH_REJECTED_DM]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITION_SPECIFICS.INTRO_REJECTED_DM]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITION_SPECIFICS.GATEKEEPER_REJECTED]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITION_SPECIFICS.NOT_QUALIFIED_BUDGET]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITION_SPECIFICS.NOT_QUALIFIED_AUTHORITY]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITION_SPECIFICS.NOT_QUALIFIED_NEED]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITION_SPECIFICS.NOT_QUALIFIED_TIMING]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITION_SPECIFICS.BAD_PHONE_NUMBER]: {
    color: "text-black/80",
    bg: "bg-[#FF9E89]",
  },
  [DISPOSITION_SPECIFICS.DO_NOT_CALL]: {
    color: "text-black/80",
    bg: "bg-[#FF9E89]",
  },
  [DISPOSITION_SPECIFICS.DATA_WRONG]: {
    color: "text-black/80",
    bg: "bg-[#FF9E89]",
  },
  [DISPOSITION_SPECIFICS.INTRO_REJECTED]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITION_SPECIFICS.PITCH_REJECTED]: {
    color: "text-black/80",
    bg: "bg-[#FFEFEB]",
  },
  [DISPOSITION_SPECIFICS.INTERESTED]: {
    color: "text-black/80",
    bg: "bg-[#DFF4B4]",
  },
  [DISPOSITION_SPECIFICS.QC_NOT_MET_FOR_ACCOUNT]: {
    color: "text-black/80",
    bg: "bg-[#FFBFB0]",
  },
  [DISPOSITION_SPECIFICS.OTHER_FOLLOW_UP]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
  [DISPOSITION_SPECIFICS.OTHER_DO_NOT_FOLLOW_UP]: {
    color: "text-black/80",
    bg: "bg-black/5",
  },
} as const;

interface DispositionPillI {
  disposition:
    | ValueOfObjectFields<typeof DISPOSITIONS>
    | ValueOfObjectFields<typeof DISPOSITIONS_V3>
    | ValueOfObjectFields<typeof DISPOSITION_SPECIFICS>;
  className?: string;
}

const DispositionPill: FC<DispositionPillI> = ({ disposition, className }) => {
  return (
    <div
      className={clsx(
        "typography-body-4 w-fit truncate text-nowrap rounded px-2 py-1",
        DISPOSITION_BADGE_CSS_PROPERTIES[disposition]?.bg,
        DISPOSITION_BADGE_CSS_PROPERTIES[disposition]?.color,
        className
      )}
    >
      {DISPOSITIONS_STRING_MAP[
        disposition as ValueOfObjectFields<typeof DISPOSITIONS>
      ] ||
        DISPOSITIONS_V3_MAP[
          disposition as ValueOfObjectFields<typeof DISPOSITIONS_V3>
        ] ||
        DISPOSITION_SPECIFICS_MAP[
          disposition as ValueOfObjectFields<typeof DISPOSITION_SPECIFICS>
        ] ||
        disposition}
    </div>
  );
};

export default DispositionPill;
